"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsFlexContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A flexible container with three sections: Left, Center, and Right.
 * Each section occupies 33.33% of the container width.
 * 
 * @param {object} props - The properties for the container.
 * @param {React.ReactNode} props.children - The child components for the container.
 * @param {object} [props.sx] - The style object for the root Box.
 * @param {string} [props.className] - The class name for the root Box.
 * @returns {JSX.Element} The DmsFlexContainer component.
 */
const DmsFlexContainer = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const left = _react.default.Children.toArray(children).find(child => child.type.displayName === "Left") || /*#__PURE__*/_react.default.createElement(Left, null);
  const center = _react.default.Children.toArray(children).find(child => child.type.displayName === "Center") || /*#__PURE__*/_react.default.createElement(Center, null);
  const right = _react.default.Children.toArray(children).find(child => child.type.displayName === "Right") || /*#__PURE__*/_react.default.createElement(Right, null);
  return /*#__PURE__*/_react.default.createElement(_Box.default, _extends({
    display: "flex",
    width: "100%",
    className: "dms-flex-container"
  }, props), /*#__PURE__*/_react.default.createElement(_Box.default, _extends({
    flex: "1 1 33.33%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  }, left.props), left.props.children), /*#__PURE__*/_react.default.createElement(_Box.default, _extends({
    flex: "1 1 33.33%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, center.props), center.props.children), /*#__PURE__*/_react.default.createElement(_Box.default, _extends({
    flex: "1 1 33.33%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, right.props), right.props.children));
};
exports.DmsFlexContainer = DmsFlexContainer;
DmsFlexContainer.propTypes = {
  children: _propTypes.default.node,
  sx: _propTypes.default.object,
  className: _propTypes.default.string
};

/**
 * Left section for the DmsFlexContainer.
 * 
 * @param {object} props - The properties for the Left section.
 * @param {React.ReactNode} props.children - The child components for the Left section.
 * @param {object} [props.sx] - The style object for the Left Box.
 * @param {string} [props.className] - The class name for the Left Box.
 * @returns {JSX.Element} The Left section component.
 */
const Left = _ref2 => {
  let {
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, props, children);
};
Left.displayName = "Left";
Left.propTypes = {
  children: _propTypes.default.node,
  sx: _propTypes.default.object,
  className: _propTypes.default.string
};
DmsFlexContainer.Left = Left;

/**
 * Center section for the DmsFlexContainer.
 * 
 * @param {object} props - The properties for the Center section.
 * @param {React.ReactNode} props.children - The child components for the Center section.
 * @param {object} [props.sx] - The style object for the Center Box.
 * @param {string} [props.className] - The class name for the Center Box.
 * @returns {JSX.Element} The Center section component.
 */
const Center = _ref3 => {
  let {
      children
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, props, children);
};
Center.displayName = "Center";
Center.propTypes = {
  children: _propTypes.default.node,
  sx: _propTypes.default.object,
  className: _propTypes.default.string
};
DmsFlexContainer.Center = Center;

/**
 * Right section for the DmsFlexContainer.
 * 
 * @param {object} props - The properties for the Right section.
 * @param {React.ReactNode} props.children - The child components for the Right section.
 * @param {object} [props.sx] - The style object for the Right Box.
 * @param {string} [props.className] - The class name for the Right Box.
 * @returns {JSX.Element} The Right section component.
 */
const Right = _ref4 => {
  let {
      children
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, props, children);
};
Right.displayName = "Right";
Right.propTypes = {
  children: _propTypes.default.node,
  sx: _propTypes.default.object,
  className: _propTypes.default.string
};
DmsFlexContainer.Right = Right;